import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Datagrid from '../../../../UI/Datagrid';
import ActionsDropdown from '../../../Dashboard/helpers/ActionsDropdown';
import { dashboardCustomizeAvailableGroupData } from '../constants';

const AGSection = ({ values, ...props }) => {
  const { t } = useTranslation('app');
  const columns = [
    {
      dataField: 'groupName',
      text: 'Group',
      sort: true,
      formatter: (cell, row) => formatGroupName(cell, row),
    },
    {
      dataField: 'numWarnings',
      text: 'Warnings',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'numAlarms',
      text: 'Alarms',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'numErrors',
      text: 'Errors',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'numSensors',
      text: 'Sensors',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'numOverriden',
      text: 'Overridden',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'state',
      text: 'State',
      sort: true,
      headerStyle: { width: 90 },
      formatter: formatState,
      filterValue: formatState,
    },
    {
      dataField: 'maps',
      text: 'Maps',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
      formatter: formatMaps,
    },
  ];
  const defaultSorted = [
    {
      dataField: 'groupName',
      order: 'asc',
    },
  ];
  const ctxMenuOptions = [
    [
      {
        name: 'View group',
        action: (row, rowIndex) => {},
      },
      {
        name: 'Set at rest',
      },
      {
        name: 'Set in operation',
        action: (row, rowIndex) => {},
      },
      {
        name: 'Edit group',
        action: (row, rowIndex) => {},
      },
      {
        name: 'Maintain database',
        action: (row, rowIndex) => {},
      },
    ],
  ];
  function rowStyle(row) {
    const style = {};
    style.backgroundColor = row.color && row.color.toLowerCase();
    return style;
  }

  function formatGroupName(cell, row) {
    return (
      <a
        className="group-name"
        onClick={() => {
          props.updateShouldDisplayCMV(true);
          props.setGroup({
            name: row.groupName,
            state: row.state,
          });
        }}
      >
        {cell}
      </a>
    );
  }
  function formatState(cell) {
    if (cell) {
      return t('At rest');
    }
    return t('In operation');
  }
  function formatMaps(cell, row) {
    const Wrapper = ({ children, ...props }) => (
      <div
        style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
        {...props}
      >
        {children}
      </div>
    );
    if (cell) {
      return (
        <Wrapper onClick={() => {}} title={cell}>
          <i className="md-icon">explore</i>
        </Wrapper>
      );
    }
    return cell;
  }
  const actions = [
    {
      label: 'At rest',
      action: () => {},
    },
    {
      label: 'In operation',
      action: () => {},
    },
    {
      label: 'Sensor disable',
      action: () => {},
    },
    {
      label: 'Sensor enable',
      action: () => {},
    },
  ];
  return (
    <>
      <div className="d-flex justify-content-between align-items-end mb-10">
        <div>
          {values.title ? <h1>{values.title}</h1> : null}
          {values.description ? (
            <span style={{ fontStyle: 'italic' }}>{values.description}</span>
          ) : null}
        </div>
        <ActionsDropdown options={actions} />
      </div>
      <Datagrid
        datagridProps={{
          keyField: 'groupId',
          data: dashboardCustomizeAvailableGroupData,
          columns,
          defaultSorted,
          rowStyle,
          //   selectRow,
        }}
        classes="mobile-datagrid-responsive"
        ctxMenuId="AvailableGroups-context"
        ctxMenuOptions={ctxMenuOptions}
        exportProps={{
          fileName: `AlarmList-${moment().format('MM-DD-YYYY')}.csv`,
        }}
      />
    </>
  );
};

export default AGSection;
